import { TabView, TabPanel } from 'primereact/tabview';
import { TabsProps } from './TabsProps';
import deleteIcon from '@/assets/icons/delete.svg';
import editIcon from '@/assets/icons/iconUpdate.svg';
import { Tooltip } from 'primereact/tooltip';

const Tabs: React.FC<TabsProps> = ({
  activeIndex = 0,
  setActiveIndex,
  tabs,
  tabsStyle,
  onDelete,
  onEdit,
  showAction = false,
  type = 'module',
  bgColor = 'bg-primary',
}) => {
  return (
    <div className={`${tabsStyle || ''} pl-0.5`}>
      <div className="flex items-baseline justify-start space-x-1 overflow-visible">
        <TabView
          unstyled
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex && setActiveIndex(e.index)}
          className="flex flex-col"
          panelContainerStyle={{ width: '100%' }}
        >
          {tabs?.map((tab, index) => {
            return (
              <TabPanel
                key={tab.id}
                header={
                  <div className="flex flex-col">
                    <div
                      className={`cursor-pointer text-center px-4 py-2 min-w-[198px] max-w-[300px] h-[50px] font-raleway text-base leading-8
                    ${index === 0 ? 'rounded-l-[4.2px]' : ''} 
                    ${index === tabs.length - 1 ? 'rounded-r-[4.2px]' : ''}
                    ${index < tabs.length - 1 ? 'rounded-r-[4.2px] border-[1.165px] border-onyx ml-[0.65px]' : ''}
                    ${activeIndex === index ? `border-none ${bgColor} text-black font-bold shadow-md` : 'bg-almostBlack text-slateGray'}
                  `}
                    >
                      <div
                        className="truncate w-full overflow-hidden text-ellipsis whitespace-nowrap"
                        data-pr-tooltip={tab.title}
                        data-pr-position="top"
                      >
                        {tab.title}
                      </div>
                      <Tooltip
                        target="[data-pr-tooltip]"
                        style={{
                          backgroundColor: 'black',
                          color: '#fff',
                          borderRadius: '4px',
                          padding: '8px 12px',
                          maxWidth: '300px',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                          fontSize: '14px',
                          fontFamily: 'Raleway, sans-serif',
                        }}
                      />
                    </div>
                    {showAction && (
                      <div className="flex justify-center mt-2 gap-2 mb-2">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            onEdit?.(tab.id);
                          }}
                          className="flex justify-center items-center w-[26px] h-[26px] bg-[#FFFFFF] rounded-[5.65px] hover:opacity-80 cursor-pointer"
                        >
                          <img src={editIcon} alt="edit" className="w-4 h-4" />
                        </span>
                        {tabs.length > 1 && type === 'module' && (
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              onDelete?.(tab.id);
                            }}
                            className="flex justify-center items-center w-[26px] h-[26px] bg-[#BD292F] rounded-[5.65px] hover:opacity-80 cursor-pointer"
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              className="w-4 h-4"
                            />
                          </span>
                        )}
                        {type === 'evaluation' && (
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              onDelete?.(tab.id);
                            }}
                            className="flex justify-center items-center w-[26px] h-[26px] bg-[#BD292F] rounded-[5.65px] hover:opacity-80 cursor-pointer"
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              className="w-4 h-4"
                            />
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                }
              ></TabPanel>
            );
          })}
        </TabView>
      </div>
    </div>
  );
};

export default Tabs;
